<div class="container-fluid text-center">
  <form class="form-signup shadow p-3 mb-5 bg-white rounded" [formGroup]="registerForm" (ngSubmit)="submitRegister()">
    <img routerLink="/" class="mb-4" src="https://cdn.iconscout.com/icon/free/png-512/koala-bear-lazy-honey-wild-animal-33903.png" width="60" height="60" alt="">
    <h1 class="h3 mb-3 font-weight-normal">Registro</h1>
    <label for="inputUserName" class="sr-only">Nombre</label>
    <input type="text" id="inputUserName" class="form-control mb-3" placeholder="Nombre" formControlName="userName" required autofocus>
    <label for="inputEmail" class="sr-only">Email</label>
    <input type="email" id="inputEmail" class="form-control mb-3" placeholder="Email"  formControlName="email" required>
    <label for="inputPassword" class="sr-only">Contraseña</label>
    <input type="password" id="inputPassword" class="form-control mb-3" placeholder="Contraseña" formControlName="password" required>    
    <div *ngIf="errorReg" class="alert alert-danger" role="alert" > 
      Debes introducir un nombre, un correo y una contraseña validos
      <!-- <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button> -->
    </div>
    <button type="submit" class="btn btn-outline-success my-2 my-sm-0"> Registrarse </button>
    <div class="or-container">
      <div class="line-separator"></div>
      <div class="or-label">or</div>
      <div class="line-separator"></div>
    </div>
    <a  class="btn btn-outline-light my-2 my-sm-0" role="button" style="color:green;border-width: 1px; border-color: green ;" href="https://karmic-koala-backend.vercel.app/auth/google/callback" ><img src="https://img.icons8.com/color/16/000000/google-logo.png"> Sign in with Google</a>
  </form>
</div>